// extracted by mini-css-extract-plugin
export default {"quick-order-content__container":"quick-order-content__container_Yu_N5n2s","sticky-section":"sticky-section_vvB8GH1a"};